import { render, staticRenderFns } from "./OtPointsUser.vue?vue&type=template&id=1fa56d26&scoped=true&"
import script from "./OtPointsUser.vue?vue&type=script&lang=js&"
export * from "./OtPointsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa56d26",
  null
  
)

export default component.exports